import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { formatDateFit } from '../screens/buyer/BuyerRequestDetails'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import PopupModal from './PopupModal'
import { convertToLocalDate, ValidateAPI } from '../utils/Utils'
import axiosInstance from '../api/axiosInstance'

const Comments = ({ crId, poNumber, sku, status, refresh }) => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const [commentsData, setCommentsData] = useState([])
  const [commentInput, setCommentInput] = useState('')
  const [showSubmitCommentModal, setShowSubmitCommentModal] = useState(false)
  const { t } = useTranslation()
  const [errorMessage, setErrorMessage] = useState('');
  const {
    Comments,
    SubmitComment,
    Activities,
    Nocommentsaddedyet,
    Enteracommenthere
  } = t('CommentsPage')
  const {  SpecialCharactersErrorMessage } = t('MessageBOXpage')

  const fetchCommentsData = () => {
    axiosInstance
      .get(`/api/get-all-cr-activity-by-crid?hftcrid=${crId}`)
      .then((res) => {
        setCommentsData(res?.data)
      })
  }

  const closeSubmitCommentModal = () => {
    setShowSubmitCommentModal(false)
  }

  const openSubmitCommentModal = () => {
    setShowSubmitCommentModal(true)
  }

  const handleSubmitComment = () => {
    setErrorMessage('')
    const payload = [
      {
        hftcrid: crId,
        po_number: poNumber,
        added_by_role_name:
          user?.roleName === 'SUPPLIER_ROLE' ? 'SUPPLIER' : 'BUYER',
        added_by_name:
          user?.roleName === 'SUPPLIER_ROLE'
            ? user?.supplierName
            : user?.fullName,
        comment: commentInput,
        type: 'Comment',
        SKU: sku
      }
    ]
    axiosInstance
      .post(`/api/create-cr-activity`, payload)
      .then((response) => {
        alert(i18next.t('VendorPopUp.Commentaddedsuccessfully'))

        setCommentsData((prevData) => [response?.data?.[0], ...prevData])
        setCommentInput('')
      })
      .catch((error) => {
        alert(i18next.t('VendorPopUp.Somethingwentwrong'))
      })
    closeSubmitCommentModal()
  }

  useEffect(() => {
    setTimeout(() => {
      if (crId) fetchCommentsData()
    }, 200);
  }, [crId, refresh])
  return (
    <div className='flex flex-col gap-3'>
      {
        user?.userGroupName !== "OVERSEAS_ROLE" && status !== true &&
        <div className='w-full flex justify-start items-start mt-1 flex-col gap-4'>
          <div>
            <p className='font-semibold text-xl'>{ }</p>
          </div>
            <div className='w-full flex justify-between items-start gap-4'>
              <div className='w-[90%] flex flex-col'>
                <textarea
                  className='w-full outline-none border border-gray-400 p-2 rounded-md text-xs bg-yellow-300 placeholder-black'
                  placeholder={Enteracommenthere}
                  value={commentInput}
                  maxLength={501}
                  onChange={(e) => {
                    const val = e.target.value;
                    const specialCharRegex = /[^a-zA-Z0-9\s.,!?_-]/;
                    
                    if (specialCharRegex.test(val)) {
                      setErrorMessage(SpecialCharactersErrorMessage);
                    } else if (val.length > 500) {
                      setErrorMessage("Maximum 500 characters allowed");
                    } else {
                      setErrorMessage("");
                    }
                    setCommentInput(val);
                  }}
                />
                <div className="flex justify-between items-center mt-1 text-xs text-gray-400">
                  <span className="error-text text-red-500">{errorMessage}</span>
                  <div className="char-count">{commentInput?.length} / 500</div>
                </div>
              </div>
              <button
                className='w-[10%] text-xs font-medium rounded-md bg-[#0059A8] flex justify-center items-center h-[39px] text-white disabled:bg-gray-400 disabled:cursor-not-allowed disabled:text-gray-200'
                onClick={openSubmitCommentModal}
                disabled={commentInput.length === 0 || errorMessage}
              >
                {SubmitComment}
              </button>
            <PopupModal
              isOpen={showSubmitCommentModal}
              message={i18next.t('VendorPopUp.Doyouwanttosubmitthiscomment')}
              onCancel={closeSubmitCommentModal}
              cancelText={i18next.t('AcceptModal.Cancel')}
              onConfirm={handleSubmitComment}
              confirmText={i18next.t('AcceptModal.Confirm')}
            />
          </div>
        </div>
      }
      <div className='w-full flex justify-start items-start mt-1 flex-col gap-4'>
        <div>
          <p className='font-semibold text-xl'>{Activities}</p>
        </div>
        <div className='w-full border-l-2 border-[#0059A8] flex flex-col items-start justify-start gap-4 text-xs p-3'>
          {commentsData?.length > 0 ? (
            commentsData?.map((comment, index) => (
              <div
                className='flex flex-col gap-3 justify-start items-start border-b border-[#E6EDFF] py-2'
                key={comment?.comment_id + index}
              >
                <p className='font-semibold text-sm'>
                  {(comment?.ADDED_BY_ROLE_NAME
                    ? comment.TYPE + ' Added by ' + comment.ADDED_BY_ROLE_NAME + (comment?.ADDED_BY_NAME ? ' - ' + comment.ADDED_BY_NAME : '') + ':'
                    : comment.TYPE + ' Added :')}
                </p>
                <p>{comment?.MESSAGE}</p>
                <p className='-mt-1 text-gray-400'>
                  {convertToLocalDate(comment?.CREATION_DATE)}
                  {/* {formatDateFit(comment?.CREATION_DATE)} */}
                </p>
              </div>
            ))
          ) : (
            <p>{Nocommentsaddedyet}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default Comments
